function GreenCheckIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={16}
      height={16}
      viewBox="0 0 16 16"
      fill="none">
      <path
        d="M13.3337 4L6.00033 11.3333L2.66699 8"
        stroke="#007500"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default GreenCheckIcon;
